import StyledSelect from '@/components/StyledInputFields/StyledSelect.tsx';
import { ConditionAction } from '@/types/automationFields.ts';
import { getConditionActionOptions } from './conditionActionOptions.ts';

type props = {
  label: string;
  value: ConditionAction;
  onChange: (updated_value: ConditionAction) => void;
  error?: string;
  canMarkOutputsUnavailable: boolean;
};

const ConditionActionSelectField = ({
  label,
  value,
  onChange,
  error,
  canMarkOutputsUnavailable,
}: props) => {
  const options = getConditionActionOptions(canMarkOutputsUnavailable);

  return (
    <StyledSelect
      label={label}
      data={options}
      value={value}
      onChange={(v) => onChange(v as ConditionAction)}
      error={error}
      required={true}
      allowDeselect={false}
      clearable={false}
    />
  );
};

export default ConditionActionSelectField;
